"use strict";

var _interopRequireDefault = require("/home/sitc1119/.jenkins/workspace/sitceb-booking-ui-prod/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _objectSpread2 = _interopRequireDefault(require("/home/sitc1119/.jenkins/workspace/sitceb-booking-ui-prod/node_modules/@babel/runtime-corejs2/helpers/objectSpread2.js"));
var _vuex = require("vuex");
var _booking = require("@/api/bookSpace/booking");
var _SailScheduleOne = _interopRequireDefault(require("@/components/SailScheduleOne"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// import dragDialog from '@/components/DragDialog'
var _default = exports.default = {
  name: "",
  components: {
    sailSchedule: _SailScheduleOne.default
  },
  data: function data() {
    return {
      listQuery: {
        vesselCode: '',
        vesselName: '',
        voyageLeg: '',
        voyageNo: ''
      },
      checkDialogVisible: false,
      sailScheduleDialogVisible: false
    };
  },
  computed: (0, _objectSpread2.default)({}, (0, _vuex.mapGetters)(['language', 'userInfo'])),
  created: function created() {},
  mounted: function mounted() {},
  methods: {
    handleOpenVesselSearch: function handleOpenVesselSearch() {
      this.sailScheduleDialogVisible = true;
    },
    selectionChange: function selectionChange(row) {
      this.sailScheduleDialogVisible = false;
      console.log(row, 'rrrrrrrrrrrrrr');
      this.listQuery.vesselCode = row.vesselCode;
      this.listQuery.vesselName = row.vesselName;
      this.listQuery.voyageLeg = row.voyageLeg;
      this.listQuery.voyageNo = row.voyageNo;
    },
    handleSearch: function handleSearch() {
      var _this = this;
      if (!this.listQuery.vesselCode) {
        this.$message.warning(this.$t('home.warning'));
        return false;
      }
      (0, _booking.getUrlStrForHBLMat)(this.listQuery).then(function (res) {
        if (res.success) {
          _this.checkDialogVisible = false;
          window.open(res.data);
        } else {
          _this.$message.error(res.message);
        }
      });
    },
    opened: function opened() {
      console.log('opened');
    },
    handleClose: function handleClose() {
      this.checkDialogVisible = false;
    }
  }
};